export enum FireStoreCollection {
    FanListCaches = "FanListCaches",
    PublicationEvents = "PublicationEvents",
    UserNotifications = "UserNotifications",
    MessageDefaults = "MessageDefaults",
    Tenants = "Tenants",
    ShowEpisodes = "ShowEpisodes",
    Content = "Content",
    ContentItems = "ContentItems",
    ContentSeriesList = "ContentSeriesList",
    Shows = "Shows",
    ScheduledGiftOrders = "ScheduledGiftOrders",
    Users = "Users",
    TenantAssignments = "TenantAssignments",
    CheckFailures = "CheckFailures",
    Messages = "Messages",
    MessageUsers = "MessageUsers",
    Announcements = "Announcements",
    Likes = "Likes",
    Votes = "Votes",
    CommunityGroups = "CommunityGroups",
    Channels = "Channels",
    PublicAnalytics = "PublicAnalytics",
    Tiers = "Tiers",
    Episodes = "Episodes",
    MembershipHistory = "MembershipHistory",
    Roles = "Roles",
    GiftCodes = "GiftCodes",
    Automations = "Automations",
    Autoresponses = "Autoresponses",
    DisplayNames = "DisplayNames"
}

export enum UserProfileFormField {
    FullName = "fullName",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    ConfirmEmail = "confirmEmail",
    UserName = "userName",
    ShirtSize = "shirtSize",
    BirthDate = "birthDate",
    ProductID = "productID",
    Password = "password",
}
